import { Component, OnInit } from '@angular/core';
import { InjectQueryParam, LocalStorageKey } from '@ddt-web/generic-utils';
import { PartnerQueryParamKey, UrlQueryParamService } from '@ddt-web/url';
import { PartnerUserProfileService } from '@ddt-web/user-data';
import { first } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-partner-debug-info',
	templateUrl: './partner-debug-info.component.html',
	styleUrls: ['./partner-debug-info.component.scss']
})
export class PartnerDebugInfoComponent implements OnInit {

	@InjectQueryParam(PartnerQueryParamKey.MOCK_PARTNER_API) private readonly mockPartnerApi: boolean;
	@InjectQueryParam(PartnerQueryParamKey.PARTNER) private readonly partnerUrlParam: string;

	public currentPartner: string;
	public newPartner: string;
	public usingMockAPI: boolean;

	constructor(
		private partnerUserProfileService: PartnerUserProfileService,
		private urlQueryParamService: UrlQueryParamService
	) { }

	public ngOnInit(): void {
		this.partnerUserProfileService.getPartner().pipe(first()).subscribe(partner => (this.currentPartner = partner));

		if (this.partnerUrlParam) {
			localStorage.setItem(LocalStorageKey.SsoInitiatedFrom, this.partnerUrlParam);
			localStorage.setItem(LocalStorageKey.ExtSso, 'true');
		}

		if (this.mockPartnerApi) {
			localStorage.setItem(LocalStorageKey.MockPartnerApi, String(this.mockPartnerApi));
		}

		const mockSsoToken = localStorage.getItem(LocalStorageKey.SsoInitiatedFrom);
		if (mockSsoToken) {
			this.currentPartner = mockSsoToken;
		}

		this.usingMockAPI = this.mockPartnerApi || localStorage.getItem(LocalStorageKey.MockPartnerApi) === 'true';

	}

	public editPartner(partner): void {
		this.newPartner = partner;
	}

	public setPartner(): void {
		this.currentPartner = this.newPartner;
		this.newPartner = null;
		localStorage.setItem(LocalStorageKey.SsoInitiatedFrom, this.currentPartner);
		localStorage.setItem(LocalStorageKey.ExtSso, 'true');

		this.urlQueryParamService.addQueryParamAndReload(PartnerQueryParamKey.PARTNER, this.currentPartner);
	}

	public resetPartner(): void {
		localStorage.removeItem(LocalStorageKey.SsoInitiatedFrom);
		localStorage.removeItem(LocalStorageKey.ExtSso);
		localStorage.removeItem(LocalStorageKey.MockPartnerApi);

		this.urlQueryParamService.addQueryParamAndReload(PartnerQueryParamKey.PARTNER, null);
	}

	public toggleMockAPIs(): void {
		if (!this.usingMockAPI) {
			localStorage.setItem(LocalStorageKey.MockPartnerApi, 'true');
			this.usingMockAPI = true;
		} else {
			localStorage.removeItem(LocalStorageKey.MockPartnerApi);
			this.usingMockAPI = false;
		}

		this.urlQueryParamService.addQueryParamAndReload(PartnerQueryParamKey.MOCK_PARTNER_API, null);
	}
}
